export enum UserType {
    SYSTEM = "SYSTEM",
    ISO="ISO",
    ADMIN="ADMIN",
    SUB_ISO="SUB_ISO",
    AGENT_OFFICE="AGENT_OFFICE",
    MERCHANT="MERCHANT"
}
